const INITIAL_STATE = {
  login: { values: [], error: null, loading: false },
};

export default function (state = INITIAL_STATE, action) {
  return {
    ...state,
    login: { values: action.payload, error: null, loading: true },
  };
}
